(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/error.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/error.js');
"use strict";


const CartError = () => React.createElement("p", null, "Du m\xE5ste v\xE4lja en lott");
svs.tickets_giftshop.gift.giftform.cart.components.CartError = CartError;

 })(window);